import {
  compose,
  withProps,
  renderNothing,
  branch,
} from 'recompose';

export const isTaopixProject = ({ type }) => type === 'taopixProject';
export const isTaopixOfflineProject = ({ displayOptions }) => !!displayOptions.isTaopixOffline;

export const withTypeProps = compose(
  withProps(({
    product: {
      type,
    },
  }) => ({
    type,
  })),
);

export const renderNothingOnTaopixProject = compose(
  withTypeProps,
  branch(
    isTaopixProject,
    renderNothing,
  ),
);



// WEBPACK FOOTER //
// ./src/Common/Helpers/CheckTaopixProject.js